import { useState } from "react";

// "Regenerate" with nothing to say is meaningless — same inputs, same output.
// This pairs every regenerate action with an optional note that gets folded
// into the next AI call as extra guidance ("shorter", "emphasize the yard").
// Leaving it blank just re-runs as before.
export default function RegenerateBar({ onRegenerate, loading, placeholder = "What should change? (optional)" }) {
  const [note, setNote] = useState("");

  const submit = () => {
    onRegenerate(note.trim());
    setNote("");
  };

  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 8, flexWrap: "wrap" }}>
      <input
        value={note}
        onChange={(e) => setNote(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !loading) { e.preventDefault(); submit(); } }}
        placeholder={placeholder}
        disabled={loading}
        style={{ flex: 1, minWidth: 160, background: "#f7faf8", border: "1px solid #d8ede6", borderRadius: 8, padding: "7px 10px", fontSize: 12, color: "#1c2b25", fontFamily: "'Outfit',sans-serif", outline: "none" }}
      />
      <button type="button" className="s-link-btn" onClick={submit} disabled={loading}>
        {loading ? "…" : "↻ regenerate"}
      </button>
    </div>
  );
}
